import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../helpers/EventEmitter'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import { PopupAction } from './PopupAction'
import classes from './index.module.scss'

export const PopupAlertError = () => {
  const dispatch = useDispatch()

  /* error {
    title: string,
    messages: [string],
    children: node,
    callback: func (run when close popup)
    button: string
  } */
  const [error, setError] = useState(null)

  useEffect(() => {
    EventEmitter.subscribe(SHOW_POPUP_ERROR, setError)
    return () => EventEmitter.unsubscribe(SHOW_POPUP_ERROR, setError)
  }, [])

  const handleClose = () => {
    if (error?.callback) {
      dispatch(error?.callback)
    }
    if (error?.closeFunction) {
      error?.closeFunction()
    }

    setError(null)
  }

  return (
    <PopupAction
      title={error?.title || 'common.ALERT'}
      isShow={error !== null}
      handleClose={handleClose}
      btnSubmit={{
        label: error?.button || 'common.CLOSE',
        style: {},
        event: handleClose,
        isI18n: true,
      }}
    >
      {error?.children || (
        <div className={classes.popupAlertErrorContainer}>
          <Icon
            className="icon-alert"
            style={{ color: '#E8B714', fontSize: 38 }}
          />
          <div className={classes.messageContainer}>
            {error?.messages &&
              error.messages.map((message, index) => (
                <Element key={index} style={{ color: '#3A414B' }}>
                  {message}
                </Element>
              ))}
          </div>
        </div>
      )}
    </PopupAction>
  )
}
